import AboutSection from "../../Components/AboutSection/AboutSection";
import classesCss from './AboutSections.module.css'

const AboutSections = ({sections}) => {
    return (
        <div className={classesCss.about__sections}>
            {
                sections.map(({text, image, header, link}, index) => <AboutSection key={index} reverse={index % 2 === 0} image={{
                    src: image.src,
                    height: image.height,
                    width: image.width,
                }} header={header} text={text} link={link}/>)
            }
        </div>
    );
};

export default AboutSections;